import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CouponService } from "app/services/campaign/coupon.service";
import { Campaign3KontableComponent } from "../components/campaign-3-kontable/campaign-3-kontable.component";
import { KontableComponent } from "app/modules/UIKit/components/kontable/kontable.component";
import { Campaign3BreadcrumbComponent } from "../components/campaign-3-breadcrumb/campaign-3-breadcrumb.component";
import { BreadCrumbModel } from "../models/campaign-3-breadcrumb.model";
import { Campaign3TestService } from "../services/campaign3testservice";
import { Campaign3Service } from "../services/campaign3.service";
import { MessageService } from "primeng/primeng";
import { Campaign2Service } from "app/services/campaign-2.0/campaign2.service";



@Component({
  selector: 'app-coupon-list-3',
  templateUrl: './coupon-list-3.component.html',
  styleUrls: ['./coupon-list-3.component.css']
})
export class CouponList3Component implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  dateFilter = KontableComponent.DateFilter;
  numberFilter = KontableComponent.NumberFilter;
  textFilter = KontableComponent.TextFilter;
  selectFilter = KontableComponent.SelectFilter;
  noFilter = KontableComponent.NoFilter;
  showEditForm = false;
  couponToEdit: any;


  @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
  breadcrumbs: Array<BreadCrumbModel> = [];

  idAction: number

  @ViewChild('table') table: Campaign3KontableComponent;
  @Output() getFirstSearch: EventEmitter<any> = new EventEmitter();

  singleAction: any;

    operationCoupon: {
    couponCode?: string,
    barcode: string,
    operation: string,
    cardId?: number,
    cardNo?: string,
    customerId?: number,
    touchpointCode?: string
  }

  constructor(
    public couponService: CouponService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public testService: Campaign3TestService,
    public campaign3Service: Campaign3Service,
    private messageService: MessageService,
    public campaignService: Campaign2Service,
  ) {
    couponService.messageInstanceId = activatedRoute.snapshot.params['messageInstanceId'];
  }
  ngOnInit(): void {

    // Recupera il parametro dall'URL
    this.activatedRoute.params.subscribe(params => {
      const id = params['messageInstanceId'];
      console.log('ID from URL:', id);
      this.idAction = id;
    });



    this.testService.getSingleAction(this.idAction).subscribe(
      res => {
     
        this.singleAction=res;
       
        console.log(this.singleAction.data);

        this.initBreadCrumbs();
      } 
    );
    

  
    setTimeout(() => {
      this.firstSearch();
    }, 100);
  }


  firstSearch() {
    if (this.table) {
      this.table.refresh();
    }
  }
  //TODO
  initBreadCrumbs() {
    let bc1 = new BreadCrumbModel();
    bc1.code = "bc1";
    bc1.description = "Coupons";
    this.breadcrumbs.push(bc1);
  
    let bc2 = new BreadCrumbModel();
    bc2.code = "bc2";
    bc2.description = this.idAction.toString();
    this.breadcrumbs.push(bc2);
  
    if (this.singleAction.data) {
      if (this.singleAction.data.name) {
        let bc3 = new BreadCrumbModel();
        bc3.code = "bc3";
        bc3.description = this.singleAction.data.name;
        this.breadcrumbs.push(bc3);
      }
  
      if (this.singleAction.data.code) {
        let bc4 = new BreadCrumbModel();
        bc4.code = "bc4";
        bc4.description = this.singleAction.data.code;
        this.breadcrumbs.push(bc4);
      }
    } else {
      console.log("Proprietà 'data' non trovata nell'oggetto res.");
    }
  }
  

  onEditCoupon(coupon: any) {
    console.log("coupon", coupon);
    this.couponToEdit = coupon;
    this.showEditForm = true;
  }


  saveCoupon(couponData: any) {
    this.couponService.editCoupon(couponData).subscribe(() => {
      this.table.refresh();
      this.showEditForm = false;
    });
  }

  deleteCoupon(couponData: any) {
    this.couponService.deleteCoupon(couponData.id).subscribe(() => this.table.refresh());
  }

  goBack() {
    this.router.navigate(['/campaign-list-3']);
  }

  breadcrumbClicked(breadcrumb:BreadCrumbModel) {
    if (breadcrumb.routerLink) {
        this.router.navigate([breadcrumb.routerLink]);
      } else {
        console.log("nessuna route implementata");
      }
}
showMenu = false;
currentOpenedRow;

toggleMenu(id: number) {

  if (this.showMenu && this.currentOpenedRow !== id) {
      this.showMenu = false;
  }

  this.currentOpenedRow = id;
  this.showMenu = !this.showMenu;
}
checkAlreadyDeleted(){
  //todo
}


viewCouponHistory(coupon) {

  //this.router.navigate([`coupon-history/${this.campaignService.customerId}/${this.campaignService.clientCustomerId}/${coupon.id}`, {previousTab: this.couponTab}])
}

printCoupon(event: any, operation: string) {
  this.operationCoupon = {
    couponCode: event.coupon_code,
    barcode: event.barcode,
    operation: operation,
    cardNo: event.card_no,
    touchpointCode: "KONCENTRO.GUI",

  }
  this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
    this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
  });
}

reserveCoupon(event) {
  this.operationCoupon = {
    couponCode: event.coupon_code,
    barcode: event.barcode,
    operation: "R",
    cardNo: event.card_no,
    touchpointCode: "KONCENTRO.GUI",
  }
  this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
    this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
  });
}

useCoupon(event) {
  this.operationCoupon = {
    couponCode: event.coupon_code,
    barcode: event.barcode,
    operation: "U",
    cardNo: event.card_no,
    touchpointCode: "KONCENTRO.GUI",
  }
  this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
    this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
  });
}

undoReserveCoupon(event) {
  this.operationCoupon = {
    couponCode: event.coupon_code,
    barcode: event.barcode,
    operation: "UR",
    cardNo: event.card_no,
    touchpointCode: "KONCENTRO.GUI",
  }
  this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
    this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
  });
}

undoUseCoupon(event) {
  this.operationCoupon = {
    couponCode: event.coupon_code,
    barcode: event.barcode,
    operation: "UU",
    cardNo: event.card_no,
    touchpointCode: "KONCENTRO.GUI",
  }
  this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
    this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
  });
}


}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/coupon-list-3/coupon-list-3.component.ts